import React from 'react';
import appTypes from '../../../../constants/types';
import SectionCard from '../../../../components/section-card';
import { TextDataField } from '../../../../components/data-fields';

export const JiraAccountDetails = ({ ticket }) => (
  <SectionCard title="Account information">
    <TextDataField
      name="Name"
      value={ticket && ticket.ticket_data.name} />
    <TextDataField
      name="Email"
      value={ticket && ticket.ticket_data.email} />
  </SectionCard>
);

JiraAccountDetails.propTypes = {
  ticket: appTypes.ticket.props,
};
JiraAccountDetails.defaultProps = {
  ticket: appTypes.ticket.default,
};
